import { useEffect, useState } from 'react'

const TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'

export function useTurnstile() {
    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        if (window.turnstile) {
            setIsLoaded(true)
            return
        }

        const script = document.createElement('script')
        script.src = TURNSTILE_SCRIPT_URL
        script.async = true
        script.defer = true
        script.onload = () => setIsLoaded(true)
        document.head.appendChild(script)

        return () => {
            // Don't remove script on unmount to avoid reloading it unnecessarily
        }
    }, [])

    return isLoaded
}

// Add types for window.turnstile
declare global {
    interface Window {
        turnstile: {
            render: (
                container: string | HTMLElement,
                options: {
                    sitekey: string
                    theme?: 'light' | 'dark' | 'auto'
                    size?: 'normal' | 'compact' | 'flexible'
                    callback?: (token: string) => void
                    'error-callback'?: (code: string) => void
                    'expired-callback'?: () => void
                }
            ) => string
            reset: (widgetId: string) => void
            remove: (widgetId: string) => void
        }
    }
}
